import cl from 'classnames'
import styles from './Style.module.scss'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { contractsSelectors, contractsThunks } from '@/entity'
import { useDispatch, useSelector } from 'react-redux'
import { formatNumber } from '@/utils'
import { formatMillions } from '@/utils/formatMillions'

const Hero = () => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const statisticsNumber = useSelector(contractsSelectors.statisticsNumber)

	useEffect(() => {
		dispatch(contractsThunks.getStatisticsNumber())
	}, [])

	const array = [
		{
			title: formatMillions(statisticsNumber?.data?.contractCount || 0) || ' ',
			subtitle: t('contracts')
		},
		{
			title: formatNumber(statisticsNumber?.data?.organizationCount || 0) || ' ',
			subtitle: t('count_employers')
		},
		{
			title: formatMillions(statisticsNumber?.data?.employeeCount || 0) || ' ',
			subtitle: t('count_workers')
		}
	]

	return (
		<section data-section="hero" className={cl(styles.hero)}>
			<div className={cl(styles.container, styles.hero__wrapper)}>
				<h1 className={cl(styles.hero__title, 'mb-0')}>{t('intro_sub_title')}</h1>

				<div className={cl(styles.hero__card)}>
					{array.map((item, index) => (
						<div className={cl(styles.hero__cardItem)} key={index}>
							<h2 className={'mb-0'}>{item.title}</h2>
							<p className={'mb-0'}>{item.subtitle}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	)
}

export default Hero